module.exports = __webpack_public_path__ + "static/media/text-block-bg.d1b93245.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/text-block-bg.png
// module id = 175
// module chunks = 0